import styled, { css } from 'styled-components';
import { Icon } from 'src/components';
import _DevTools from 'src/containers/DevTools';
import { desktopMinWidthBP } from './constants';

export const Header = styled.header(
  ({ theme }) => css`
    position: sticky;
    top: ${theme.sz.s0};
    z-index: ${theme.zi.header};
  `,
);

export const TopStripe = styled.div(
  ({ theme }) => css`
    display: none;
    height: ${theme.sz.s10};
    background-color: ${theme.co.primary30};
    color: ${theme.co.neutral99};

    @media (min-width: ${desktopMinWidthBP}) {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: ${theme.sz.s12};
      padding: ${theme.sz.s0} ${theme.sz.s5};
    }
  `,
);

export const MainStripe = styled.div(
  ({ theme }) => css`
    display: flex;
    gap: ${theme.sz.s4};
    justify-content: space-between;
    align-items: center;
    height: ${theme.sz.s18};
    padding: ${theme.sz.s0} ${theme.sz.s5};
    background-color: ${theme.co.secondary20};
    color: ${theme.co.neutral99};

    @media (min-width: ${theme.sz.ml}) {
      gap: ${theme.sz.s8};
    }

    @media (min-width: ${desktopMinWidthBP}) {
      height: ${theme.sz.s20};
    }
  `,
);

export const Navigation = styled.nav(
  ({ theme }) => css`
    flex-grow: 1;
    display: flex;
    align-items: center;
    gap: ${theme.sz.s8};

    @media (min-width: ${desktopMinWidthBP}) {
      flex-grow: 0;
      justify-content: flex-end;
    }
  `,
);

export const NavigationList = styled.ul(
  ({ theme }) => css`
    display: none;
    gap: ${theme.sz.s8};
    margin: ${theme.sz.s0};
    padding: ${theme.sz.s0};
    ${theme.typography.heading.desktop.xs};

    @media (min-width: ${desktopMinWidthBP}) {
      display: flex;
    }
  `,
);

export const NavigationListItem = styled.li(
  () => css`
    list-style-type: none;
  `,
);

export const NavigationLink = styled.a(
  ({ theme }) => css`
    display: inline-block;
    color: inherit;
    text-decoration: none;
    transition: transform 0.5s ease;

    &:hover {
      transform: translateY(-${theme.sz.s05});
    }
  `,
);

export const SmallCtaButtonWrapper = styled.div(
  ({ theme }) => css`
    transform: translateY(-${theme.sz.s05});

    @media (min-width: ${desktopMinWidthBP}) {
      display: none;
    }
  `,
);

export const LargeCtaButtonWrapper = styled.div(
  ({ theme }) => css`
    display: none;
    transform: translateY(-${theme.sz.s05});

    @media (min-width: ${desktopMinWidthBP}) {
      display: flex;
    }
  `,
);

export const MenuButtonWrapper = styled.div(
  ({ theme }) => css`
    height: ${theme.sz.s12};
    margin-left: auto;

    @media (min-width: ${desktopMinWidthBP}) {
      display: none;
    }
  `,
);

export const MenuButton = styled.button(
  ({ theme }) => css`
    color: ${theme.co.neutral99};
    background: none;
    padding: ${theme.sz.s0};
    border: none;
    cursor: pointer;
    height: ${theme.sz.s12};
    width: ${theme.sz.s12};
  `,
);

const BurgerIcon = ({ ...props }) => <Icon {...props} name="burgerThin" useCurrentColor />;
export const MenuIcon = styled(BurgerIcon)(
  ({ theme }) => css`
    svg {
      height: 100%;
      width: 100%;
      padding: ${theme.sz.s0} calc(100% / 8);
    }
  `,
);

export const SignIn = styled(NavigationLink)(
  ({ theme }) => css`
    display: none;
    padding: ${theme.sz.s2} ${theme.sz.s6};
    color: ${theme.co.neutral99};
    ${theme.typography.button.l};

    @media (min-width: ${theme.sz.ml}) {
      display: block;
    }

    @media (min-width: ${desktopMinWidthBP}) {
      display: none;
    }
  `,
);

export const DevTools = styled(_DevTools)(
  ({ theme }) => css`
    right: ${theme.sz.s16};
    top: ${theme.sz.s3};

    @media (min-width: ${desktopMinWidthBP}) {
      right: unset;
      left: ${theme.sz.s32};
      top: ${theme.sz.s14};
    }
  `,
);
